const investmentTypeLang = {
	text_for_graph_with_nav_nc: {
		tag: 'investment.type.text_for_graph_with_nav_nc',
		fr: 'La NAV à la période de reporting sélectionnée est inconnue pour',
		en: 'The NAV at the selected reporting period is unknown for',
	},
	text_for_graph_with_nav_nc_complement: {
		tag: 'investment.type.text_for_graph_with_nav_nc_complement',
		fr: 'Vous pouvez déselectionner ces fonds grâce au filtre pour accèder aux indicateurs des autres fonds',
		en: 'You can unselect these funds with the filter to see the other funds KPIs',
	},
	portfolio_nav: {
		tag: 'investment.type.portfolio_nav',
		fr: 'NAV du portefeuille',
		en: 'Portfolio NAV',
	},
	capital_kpi: {
		tag: 'investment.type.capital_kpi',
		fr: 'KPI Capital',
		en: 'CAPITAL KPI',
	},
	value: {
		tag: 'investment.type.value',
		fr: 'DISTRIBUTIONS',
		en: 'VALUE',
	},
	performance: {
		tag: 'investment.type.performance',
		fr: 'PERFORMANCE',
		en: 'PERFORMANCE',
	},
	indicators: {
		tag: 'investment.type.indicators',
		fr: 'INDICATEURS',
		en: 'INDICATORS',
	},
	private_credit: {
		tag: 'investment.type.private_credit',
		fr: 'Dette privée',
		en: 'Private credit',
	},

	venture_capital: {
		tag: 'investment.type.venture_capital',
		fr: 'Venture Capital',
		en: 'Venture capital',
	},
	real_estate: {
		tag: 'investment.type.real_estate',
		fr: 'Immobilier',
		en: 'Real estate',
	},
	private_equity: {
		tag: 'investment.type.private_equity',
		fr: 'Capital investissement',
		en: 'Private equity',
	},
	listed_assets: {
		tag: 'investment.type.listed_assets',
		fr: 'Actifs cotés',
		en: 'Listed assets',
	},
	infrastructure: {
		tag: 'investment.type.infrastructure',
		fr: 'Infrastructure',
		en: 'Infrastructure',
	},
	hedge_fund: {
		tag: 'investment.type.hedge_fund',
		fr: 'Fonds spéculatif',
		en: 'Hedge fund',
	},
	liquid_assets: {
		tag: 'investment.type.liquid_assets',
		fr: 'Actifs liquides',
		en: 'Liquid assets',
	},
	multi_assets: {
		tag: 'investment.type.multi_assets',
		fr: 'Multi-actifs',
		en: 'Multi-assets',
	},
	get_x_funds_details: {
		tag: 'investment.type.get_x_funds_details',
		fr: 'Afficher {{count}} fonds',
		en: 'Get {{count}} funds details',
		plurals: {
			zero: {
				fr: 'Aucun fonds',
				en: 'No fund',
			},
			one: {
				fr: 'Détail du fonds',
				en: 'Get the fund details',
			},
			other: {
				fr: 'Afficher {{count}} fonds',
				en: 'Get {{count}} funds details',
			},
		},
	},
	get_x_subportfolios_details: {
		tag: 'investment.type.get_x_subportfolios_details',
		fr: 'Afficher {{count}} cantons',
		en: 'Get {{count}} sub portfolios details',
		plurals: {
			zero: {
				fr: 'Aucun canton',
				en: 'No sub portfolio',
			},
			one: {
				fr: 'Détail du canton',
				en: 'Get the sub portfolio details',
			},
			other: {
				fr: 'Afficher {{count}} cantons',
				en: 'Get {{count}} sub portfolios details',
			},
		},
	},
	get_x_assets_details: {
		tag: 'investment.type.get_x_assets_details',
		fr: 'Afficher {{count}} actifs',
		en: 'Get {{count}} assets details',
		plurals: {
			zero: {
				fr: 'Aucun actif',
				en: 'No asset',
			},
			one: {
				fr: "Détail de l'actif",
				en: 'Get the asset details',
			},
			other: {
				fr: 'Afficher {{count}} actifs',
				en: 'Get {{count}} assets details',
			},
		},
	},
	assets_data_presented_are_transparent: {
		tag: 'investment.type.assets_data_presented_are_transparent',
		fr: 'Les données des actifs présentés sont transparisées',
		en: 'Disclosed data are asset "look-through" KPI',
	},
	asset_title_realization_status_realized: {
		tag: 'investment.type.asset_title_realization_status_realized',
		fr: 'Actifs réalisés',
		en: 'Exit assets',
	},
	asset_title_realization_status_not_realized: {
		tag: 'investment.type.asset_title_realization_status_not_realized',
		fr: 'Actifs non réalisés',
		en: 'Active assets',
	},
	asset_sub_title_realization_status_not_realized: {
		tag: 'investment.type.asset_sub_title_realization_status_not_realized',
		fr: 'dont actifs partiellement réalisés',
		en: 'include partial exit assets',
	},
};

export default investmentTypeLang;
